export const getQueryInstances = {
  variable: [
    '$instanceId: ID!',
    '$duration: Duration!',
    '$teamId: String!',
    '$properties: [KeyValuePair!]!',
  ],
  query: `
  getInstanceDetail(duration: $duration, instanceId: $instanceId, teamId: $teamId, properties: $properties) {
        key: id
        label: name
        language
        isActive
        availability
        attributes {
          name
          value
        }
      }
    `,
};

const readMetricsValue = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  query: `
      readMetricsValue: readMetricsValue(condition: $condition, duration: $duration)`,
};

export const getLabeledLatestValue = {
  variable: [
    '$condition: MetricsCondition!,  $labels: [String!]!,$duration: Duration!, $sortCriteria: [SortCriteria!]',
  ],
  query: `
  readLabeledMetricsLatestValue: readLabeledMetricsLatestValue(condition: $condition, labels: $labels,duration: $duration, sortCriteria: $sortCriteria) {
    label
    value
  }`,
};
export const getLabelCountData = {
  variable: [
    '$condition: MetricsCondition!,  $labels: [String!]!,$duration: Duration!',
  ],
  query: `
  readMetricsLabelCount: readMetricsLabelCount(condition: $condition, labels: $labels,duration: $duration)`,
};

export const getMetricData = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  query: `
      readMetricsValue: readMetricsValue(condition: $condition, duration: $duration)`,
};

export const getServiceForTeamWithTotalCount = {
  variable: [
    '$keyword: String',
    '$duration: Duration!',
    '$serviceReq: ServiceReq!',
    '$pagination: Pagination',
    '$permissions: [String]',
  ],
  query: `
    services: getServiceForTeamWithTotalCount(keyword: $keyword, duration: $duration, serviceReq: $serviceReq, pagination: $pagination, permissions: $permissions) {
      services {
        key: id
        label: name
        permissions
      }
      total
    }
  `,
};
